import { AppError } from "./AppError";

//

export class PaymentCardError extends AppError {
  constructor(message: string) {
    super(message);
    this.name = "PaymentCardError";
    Error.captureStackTrace(this, PaymentCardError);
  }
}

export class PaymentCardNotFoundError extends PaymentCardError {
  constructor(organizationId: string) {
    super(`Платежная карта для организации ${organizationId} не найдена.`);
    this.name = "PaymentCardNotFoundError";
    Error.captureStackTrace(this, PaymentCardNotFoundError);
  }
}
